"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importStar(require("react"));
var CSVReportService_1 = __importDefault(require("../../../Trillium.UI/TypeScript/Services/Reports/CSVReportService"));
var userRoleList = {
    TrainingProviderAdministrator: "Role - Training Provider Administrator",
    TrainingSchemeAdministrator: "Role - Training Scheme Administrator",
    MDO: "Role - Membership Development Officer",
    ICE: "Role - ICE contact",
    MDOTrainingScheme: "Role - ICE contact-TrainingScheme",
    CompanyAdmin: "Role - Company Admin"
};
var PageList = {
    CaPendingTrainee: 'CaPendingTraineesPage',
    CaAllTrainee: 'CaAllTraineesPage',
    CaSce: 'CaSces',
    ScesTrainee: 'SCEsTraineesPage',
    TsaAllTrainee: 'TsaAllTraineePage',
    TpaAllTrainee: 'TpaAllTraineePage',
    MDOTraineeSearch: 'MDOTraineeSearchPage',
    MDOSummary: 'MDOSummaryPage',
    MDOGroup: 'MDOGroupPage',
    Attributes: 'AttributesPage',
    AttributeDetails: 'AttributeDetailsPage',
    IndividualAnnualAppraisal: 'IndividualAnnualAppraisalPage',
    MyDetails: 'MyDetailsPage',
    YourPerticularTraineePage: 'YourPerticularTraineePage',
    Trainees: 'TraineesPage',
    SupervisoryTraineeIndividualAttribute: 'SupervisoryTraineeIndividualAttribute',
    SuppervisoryIndividualAppraisal: 'SuppervisoryIndividualAppraisal',
    CaPayment: 'CaPaymentPage',
    CaIndividualPayment: 'CaIndividualMonthTransactionsPage'
};
var downloadtype = {
    AllTrainees: 'AllTrainees',
    Group: 'Group',
    NonActiveTrainees: "NonActiveTrainees",
    CurrentSearch: "CurrentSearch",
    PendingTrainees: "PendingTraineesReport",
    SCEs: 'SCEs',
    SCETrainee: 'SCETraineeList',
    CaPaymentList: 'PaymentList',
    CaIndividualTransaction: 'IndividualPaymentMonthReport',
    MDOAllTrainees: 'MDOAllTrainees'
};
var csvService = new CSVReportService_1.default();
var DownloadCsvReportComponent = function (props) {
    var Contact = props.Contact, CurrentRole = props.CurrentRole, CurrentUserIPDRole = props.CurrentUserIPDRole, Admin = props.Admin, Page = props.Page, Groups = props.Groups, currentSearch = props.currentSearch;
    var _a = react_1.useState({ open: false, selectedType: '' }), modelDetails = _a[0], setModelDetails = _a[1];
    var _b = react_1.useState([]), downloadTypes = _b[0], setDownloadTypes = _b[1];
    var _c = react_1.useState(false), loader = _c[0], setLoader = _c[1];
    var _d = react_1.useState(''), currentPage = _d[0], setCurrentPage = _d[1];
    var _e = react_1.useState(''), trainingSchemeId = _e[0], setTrainingSchemeId = _e[1];
    var _f = react_1.useState(''), groupdId = _f[0], setGroupId = _f[1];
    var _g = react_1.useState(""), contactId = _g[0], setContactId = _g[1];
    var _h = react_1.useState(''), filteredName = _h[0], setFilteredName = _h[1];
    var _j = react_1.useState(''), transactionId = _j[0], setTransactionId = _j[1];
    var _k = react_1.useState(false), emailMsg = _k[0], setEmailMsg = _k[1];
    var handleChangeValue = react_1.useCallback(function (event) {
        setCurrentPage(event.target.value);
    }, []);
    var handleChangeFilteredName = react_1.useCallback(function (event) {
        setFilteredName(event.target.value);
    }, []);
    var TrainingSchemeAdministrator = userRoleList.TrainingSchemeAdministrator, TrainingProviderAdministrator = userRoleList.TrainingProviderAdministrator, MDO = userRoleList.MDO, CompanyAdmin = userRoleList.CompanyAdmin, MDOTrainingScheme = userRoleList.MDOTrainingScheme, ICE = userRoleList.ICE;
    var TsaAllTrainee = PageList.TsaAllTrainee, TpaAllTrainee = PageList.TpaAllTrainee, CaPendingTrainee = PageList.CaPendingTrainee, CaAllTrainee = PageList.CaAllTrainee, CaSce = PageList.CaSce, ScesTrainee = PageList.ScesTrainee, CaPayment = PageList.CaPayment, CaIndividualPayment = PageList.CaIndividualPayment, MDOTraineeSearch = PageList.MDOTraineeSearch, MDOGroup = PageList.MDOGroup, MDOSummary = PageList.MDOSummary;
    react_1.useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (Contact) {
            var currentUser_1, currentRoles = void 0;
            setContactId(Contact.Id);
            if (CurrentRole == MDOTrainingScheme) {
                currentUser_1 = CurrentRole === null || CurrentRole === void 0 ? void 0 : CurrentRole.replace("Role - ", "");
                var user_1 = currentUser_1 === null || currentUser_1 === void 0 ? void 0 : currentUser_1.replace("-TrainingScheme", "");
                currentRoles = Contact.ContactRoles.filter(function (x) { return x.RoleId.Name == user_1; });
                if (currentRoles) {
                    setTrainingSchemeId((_b = (_a = currentRoles[0]) === null || _a === void 0 ? void 0 : _a.TrainingScheme) === null || _b === void 0 ? void 0 : _b.Id);
                }
            }
            else if (Contact.ContactRoles) {
                currentUser_1 = CurrentRole === null || CurrentRole === void 0 ? void 0 : CurrentRole.replace("Role - ", "");
                currentRoles = Contact.ContactRoles.filter(function (x) { return x.RoleId.Name == currentUser_1; });
                if (currentRoles) {
                    setTrainingSchemeId((_d = (_c = currentRoles[0]) === null || _c === void 0 ? void 0 : _c.TrainingScheme) === null || _d === void 0 ? void 0 : _d.Id);
                }
            }
        }
        else {
            setContactId((_e = Admin === null || Admin === void 0 ? void 0 : Admin.CurrentMember) === null || _e === void 0 ? void 0 : _e.CrmId);
        }
        var queryString = window.location.search;
        var schId = queryString.replace("?ScId=", "");
        if (schId) {
            setTrainingSchemeId(schId);
        }
        if (currentSearch) {
            setFilteredName(currentSearch);
        }
        var traIdEle = document.getElementById("transactionId");
        if (traIdEle) {
            setTransactionId(traIdEle.value);
        }
        if ((_g = (_f = Admin === null || Admin === void 0 ? void 0 : Admin.CurrentMember) === null || _f === void 0 ? void 0 : _f.CrmMember) === null || _g === void 0 ? void 0 : _g.ContactRoles) {
            var roles = Admin.CurrentMember.CrmMember.ContactRoles;
            var currentUser_2 = CurrentUserIPDRole === null || CurrentUserIPDRole === void 0 ? void 0 : CurrentUserIPDRole.replace("Role - ", "");
            var currentroles = roles.filter(function (x) { return x.RoleId.Name == currentUser_2; });
            if (currentroles) {
                setTrainingSchemeId((_j = (_h = currentroles[0]) === null || _h === void 0 ? void 0 : _h.TrainingScheme) === null || _j === void 0 ? void 0 : _j.Id);
            }
        }
        var filterElement = document.getElementById('NameFilter');
        if (filterElement)
            filterElement.addEventListener('change', handleChangeFilteredName);
        var currentPageInput = document.getElementById('CurrentPage');
        if (currentPageInput) {
            if (currentPageInput.value) {
                setCurrentPage(currentPageInput.value);
            }
            currentPageInput.addEventListener('change', handleChangeValue);
        }
        var recordTypeList = [];
        if ([TrainingSchemeAdministrator, TrainingProviderAdministrator, MDOTrainingScheme, MDO, ICE].includes(CurrentRole || CurrentUserIPDRole)) {
            if ([TsaAllTrainee, TpaAllTrainee, MDOSummary].includes(currentPage || Page)) {
                recordTypeList.push({ value: "AllTrainees", label: "All trainees" });
                recordTypeList.push({ value: "CurrentSearch", label: "Current Search" });
                if (Groups)
                    recordTypeList.push({ value: "Group", label: "Group" });
                recordTypeList.push({ value: "NonActiveTrainees", label: "Non Active Trainees" });
            }
            if ([MDOGroup].includes(currentPage || Page)) {
                recordTypeList.push({ value: "Group", label: "Group" });
            }
            if ([MDOTraineeSearch].includes(Page)) {
                recordTypeList.push({ value: "MDOAllTrainees", label: "All Trainees" });
            }
        }
        if ([CompanyAdmin].includes(CurrentRole || CurrentUserIPDRole)) {
            if ([CaPendingTrainee].includes(currentPage)) {
                recordTypeList.push({ value: "PendingTraineesReport", label: "Pending Trainees Report" });
            }
            if ([CaSce].includes(currentPage)) {
                recordTypeList.push({ value: "SCEs", label: "SCEs Report" });
            }
            if ([ScesTrainee].includes(currentPage)) {
                recordTypeList.push({ value: "SCETraineeList", label: "SCE trainee list" });
            }
            if ([CaPayment].includes(currentPage)) {
                recordTypeList.push({ value: "PaymentList", label: "Payment List" });
            }
            if ([CaIndividualPayment].includes(currentPage)) {
                recordTypeList.push({ value: "IndividualPaymentMonthReport", label: "Individual Payment Month Report" });
            }
        }
        if ([CompanyAdmin].includes(CurrentRole)) {
            if ([CaAllTrainee].includes(currentPage)) {
                recordTypeList.push({ value: "AllTrainees", label: "All trainees Report" });
            }
        }
        setDownloadTypes(recordTypeList);
        return function () {
            window.removeEventListener("change", handleChangeValue);
        };
    }, [currentPage]);
    var groutDropdown = function () {
        return react_1.default.createElement("select", { defaultValue: "default", className: 'w-100 order-list', onChange: function (e) { if (e.target.value != 'default')
                setGroupId(e.target.value); }, disabled: modelDetails.selectedType !== 'Group' || loader },
            react_1.default.createElement("option", { value: "default" }, "Select..."),
            Groups && Groups.map(function (item, index) { return (react_1.default.createElement("option", { key: index, value: item.TsaGroupId }, item.Name)); }));
    };
    var openModel = function () {
        setModelDetails(__assign(__assign({}, modelDetails), { open: true }));
    };
    var closeModel = function () {
        setLoader(false);
        setEmailMsg(false);
        setModelDetails(__assign(__assign({}, modelDetails), { open: false, selectedType: '' }));
    };
    var onTypeChange = function (value) {
        setModelDetails(__assign(__assign({}, modelDetails), { selectedType: value }));
    };
    var AllTrainees = downloadtype.AllTrainees, Group = downloadtype.Group, NonActiveTrainees = downloadtype.NonActiveTrainees, CurrentSearch = downloadtype.CurrentSearch, PendingTrainees = downloadtype.PendingTrainees, SCEs = downloadtype.SCEs, SCETrainee = downloadtype.SCETrainee, CaPaymentList = downloadtype.CaPaymentList, CaIndividualTransaction = downloadtype.CaIndividualTransaction, MDOAllTrainees = downloadtype.MDOAllTrainees;
    var onExportReport = function (emailFlag) { return __awaiter(void 0, void 0, void 0, function () {
        var response, email, individualtraineeEl, organisation, fileName, blob, link;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (emailFlag) {
                        if (Admin) {
                            email = encodeURIComponent((_b = (_a = Admin.CurrentMember) === null || _a === void 0 ? void 0 : _a.CrmMember) === null || _b === void 0 ? void 0 : _b.Email1);
                        }
                        if (Contact) {
                            email = encodeURIComponent(Contact.Email1);
                        }
                    }
                    if (![AllTrainees].includes(modelDetails.selectedType)) return [3 /*break*/, 14];
                    if (![CurrentRole, CurrentUserIPDRole].includes("Role - Company Admin")) return [3 /*break*/, 5];
                    if (!emailFlag) return [3 /*break*/, 2];
                    return [4 /*yield*/, csvService.GetCaAllTraineesReport(trainingSchemeId, setLoader, emailFlag, email)];
                case 1:
                    _g.sent();
                    return [3 /*break*/, 4];
                case 2:
                    setLoader(true);
                    return [4 /*yield*/, csvService.GetCaAllTraineesReport(trainingSchemeId, setLoader, emailFlag)];
                case 3:
                    response = _g.sent();
                    _g.label = 4;
                case 4: return [3 /*break*/, 14];
                case 5:
                    if (![CurrentRole].includes(MDOTrainingScheme)) return [3 /*break*/, 10];
                    if (!emailFlag) return [3 /*break*/, 7];
                    return [4 /*yield*/, csvService.GetBySchemeTraineesReport(contactId, MDOTrainingScheme, trainingSchemeId, setLoader, "", emailFlag, email)];
                case 6:
                    _g.sent();
                    return [3 /*break*/, 9];
                case 7:
                    setLoader(true);
                    return [4 /*yield*/, csvService.GetBySchemeTraineesReport(contactId, MDOTrainingScheme, trainingSchemeId, setLoader, "", emailFlag)];
                case 8:
                    response = _g.sent();
                    _g.label = 9;
                case 9: return [3 /*break*/, 14];
                case 10:
                    if (!emailFlag) return [3 /*break*/, 12];
                    return [4 /*yield*/, csvService.GetAllSchemeTraineesReport(contactId, CurrentRole || CurrentUserIPDRole, setLoader, emailFlag, email)];
                case 11:
                    _g.sent();
                    return [3 /*break*/, 14];
                case 12:
                    setLoader(true);
                    return [4 /*yield*/, csvService.GetAllSchemeTraineesReport(contactId, CurrentRole || CurrentUserIPDRole, setLoader, emailFlag)];
                case 13:
                    response = _g.sent();
                    _g.label = 14;
                case 14:
                    if (![Group].includes(modelDetails.selectedType)) return [3 /*break*/, 18];
                    if (!groupdId) return [3 /*break*/, 18];
                    if (!emailFlag) return [3 /*break*/, 16];
                    return [4 /*yield*/, csvService.GetAllSchemeTraineesByGroupReport(contactId, groupdId, setLoader, emailFlag, email)];
                case 15:
                    _g.sent();
                    return [3 /*break*/, 18];
                case 16:
                    setLoader(true);
                    return [4 /*yield*/, csvService.GetAllSchemeTraineesByGroupReport(contactId, groupdId, setLoader, emailFlag)];
                case 17:
                    response = _g.sent();
                    _g.label = 18;
                case 18:
                    if (![CurrentSearch].includes(modelDetails.selectedType)) return [3 /*break*/, 27];
                    if (!contactId) return [3 /*break*/, 27];
                    if (![CurrentRole, CurrentUserIPDRole].includes(MDOTrainingScheme)) return [3 /*break*/, 23];
                    if (!emailFlag) return [3 /*break*/, 20];
                    return [4 /*yield*/, csvService.GetBySchemeTraineesReport(contactId, MDOTrainingScheme, trainingSchemeId, setLoader, filteredName, emailFlag, email)];
                case 19:
                    _g.sent();
                    return [3 /*break*/, 22];
                case 20:
                    setLoader(true);
                    return [4 /*yield*/, csvService.GetBySchemeTraineesReport(contactId, MDOTrainingScheme, trainingSchemeId, setLoader, filteredName, emailFlag)];
                case 21:
                    response = _g.sent();
                    _g.label = 22;
                case 22: return [3 /*break*/, 27];
                case 23:
                    if (!emailFlag) return [3 /*break*/, 25];
                    return [4 /*yield*/, csvService.GetCurrentSearchTraineeReport(contactId, filteredName, CurrentRole || CurrentUserIPDRole, setLoader, emailFlag, email)];
                case 24:
                    _g.sent();
                    return [3 /*break*/, 27];
                case 25:
                    setLoader(true);
                    return [4 /*yield*/, csvService.GetCurrentSearchTraineeReport(contactId, filteredName, CurrentRole || CurrentUserIPDRole, setLoader, emailFlag)];
                case 26:
                    response = _g.sent();
                    _g.label = 27;
                case 27:
                    if (![NonActiveTrainees].includes(modelDetails.selectedType)) return [3 /*break*/, 31];
                    if (!emailFlag) return [3 /*break*/, 29];
                    return [4 /*yield*/, csvService.GetNonIPDTraineesReport(trainingSchemeId, setLoader, emailFlag, email)];
                case 28:
                    _g.sent();
                    return [3 /*break*/, 31];
                case 29:
                    setLoader(true);
                    return [4 /*yield*/, csvService.GetNonIPDTraineesReport(trainingSchemeId, setLoader, emailFlag)];
                case 30:
                    response = _g.sent();
                    _g.label = 31;
                case 31:
                    if (![PendingTrainees].includes(modelDetails.selectedType)) return [3 /*break*/, 33];
                    setLoader(true);
                    return [4 /*yield*/, csvService.GetPendingTraineesReport(trainingSchemeId, setLoader)];
                case 32:
                    response = _g.sent();
                    _g.label = 33;
                case 33:
                    if (![SCEs].includes(modelDetails.selectedType)) return [3 /*break*/, 37];
                    if (!emailFlag) return [3 /*break*/, 35];
                    return [4 /*yield*/, csvService.GetAllSCEsReport(contactId, setLoader, emailFlag, email)];
                case 34:
                    _g.sent();
                    return [3 /*break*/, 37];
                case 35:
                    setLoader(true);
                    return [4 /*yield*/, csvService.GetAllSCEsReport(contactId, setLoader, emailFlag)];
                case 36:
                    response = _g.sent();
                    _g.label = 37;
                case 37:
                    if (![SCETrainee].includes(modelDetails.selectedType)) return [3 /*break*/, 41];
                    individualtraineeEl = document.getElementById("IndividualSCETraineeId");
                    if (!individualtraineeEl) return [3 /*break*/, 41];
                    if (!emailFlag) return [3 /*break*/, 39];
                    return [4 /*yield*/, csvService.GetAllSCETraineesReport(trainingSchemeId, individualtraineeEl.value, setLoader, emailFlag, email)];
                case 38:
                    _g.sent();
                    return [3 /*break*/, 41];
                case 39:
                    setLoader(true);
                    return [4 /*yield*/, csvService.GetAllSCETraineesReport(trainingSchemeId, individualtraineeEl.value, setLoader, emailFlag)];
                case 40:
                    response = _g.sent();
                    _g.label = 41;
                case 41:
                    if (![MDOAllTrainees].includes(modelDetails.selectedType)) return [3 /*break*/, 43];
                    if (!filteredName) return [3 /*break*/, 43];
                    setLoader(true);
                    return [4 /*yield*/, csvService.GetMDOSearchTraineesReport(filteredName, setLoader)];
                case 42:
                    response = _g.sent();
                    _g.label = 43;
                case 43:
                    organisation = (_e = (_d = (_c = Admin === null || Admin === void 0 ? void 0 : Admin.CurrentMember) === null || _c === void 0 ? void 0 : _c.CrmMember) === null || _d === void 0 ? void 0 : _d.Organisation) === null || _e === void 0 ? void 0 : _e.Name;
                    if (![CaPaymentList].includes(modelDetails.selectedType)) return [3 /*break*/, 45];
                    if (!(trainingSchemeId && organisation)) return [3 /*break*/, 45];
                    setLoader(true);
                    return [4 /*yield*/, csvService.GetCAPayments(trainingSchemeId, organisation, setLoader)];
                case 44:
                    response = _g.sent();
                    _g.label = 45;
                case 45:
                    if (![CaIndividualTransaction].includes(modelDetails.selectedType)) return [3 /*break*/, 47];
                    if (!(trainingSchemeId && transactionId)) return [3 /*break*/, 47];
                    setLoader(true);
                    return [4 /*yield*/, csvService.GetIndividualPaymentReport(transactionId, trainingSchemeId, organisation, setLoader)];
                case 46:
                    response = _g.sent();
                    _g.label = 47;
                case 47:
                    if (response && !emailFlag) {
                        fileName = (_f = response.headers['content-disposition']) === null || _f === void 0 ? void 0 : _f.replace("attachment; filename=", "");
                        blob = new Blob([response.data], { type: 'text/csv' });
                        link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        setLoader(false);
                        link.click();
                    }
                    if (emailFlag) {
                        setEmailMsg(true);
                        setTimeout(function () { closeModel(); }, 1600);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    if (downloadTypes.length > 0) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("button", { type: "button", className: "px-0 btn-sm btn-primary btn btn-block", onClick: openModel }, [CaPendingTrainee, CaSce, ScesTrainee, ScesTrainee, CaPayment, CaIndividualPayment].includes(currentPage) ? "Download a report" : "Export a report"),
            modelDetails.open ? react_1.default.createElement(core_1.Dialog, { onClose: closeModel, "aria-labelledby": "simple-dialog-title", open: modelDetails.open, className: 'ipd-portal ipd-dialog-file-uploader', maxWidth: 'lg' },
                react_1.default.createElement(core_1.DialogTitle, { id: "simple-dialog-title", className: "up-padding" },
                    react_1.default.createElement("p", { style: { fontSize: '20px', color: 'black' } }, "Export report"),
                    react_1.default.createElement("img", { src: '/images/icons/close.svg', className: 'closeIcon cursor-pointer', onClick: function () { return closeModel(); } })),
                react_1.default.createElement(core_1.DialogContent, { className: "nopadding" },
                    react_1.default.createElement("h3", null, "Report contents"),
                    react_1.default.createElement(core_1.RadioGroup, { "aria-labelledby": "demo-radio-buttons-group-label", name: "radio-buttons-group", onChange: function (e) { return onTypeChange(e.target.value); }, value: modelDetails.selectedType, className: "up-padding" }, downloadTypes.map(function (o, index) { return react_1.default.createElement(core_1.FormControlLabel, { key: index, value: o.value, control: react_1.default.createElement(core_1.Radio, { disabled: !loader ? false : true, style: { color: "#007C92" } }), label: react_1.default.createElement("div", { className: "group_select" },
                            o.label,
                            o.value === "Group" ? react_1.default.createElement(react_1.default.Fragment, null, groutDropdown()) : null) }); })),
                    react_1.default.createElement("div", { className: "report_download_warning" },
                        react_1.default.createElement("span", null, "Large reports may take some time to generate"))),
                loader && react_1.default.createElement("div", { className: "spinner-border loading-indicator mb-2" }),
                emailMsg && react_1.default.createElement("div", { className: "row mb-2" },
                    react_1.default.createElement("div", { className: "col-1" },
                        " ",
                        react_1.default.createElement("img", { style: { height: "30px", width: "30px" }, src: "/Images/icons/success2.svg" })),
                    react_1.default.createElement("div", { className: "col" },
                        react_1.default.createElement("p", null, "Email has been sent successfully"))),
                react_1.default.createElement(core_1.DialogActions, null,
                    react_1.default.createElement(core_1.Button, { onClick: closeModel, className: 'btn btn-primary btn-primary-outline  mr-auto' }, "Cancel"),
                    react_1.default.createElement(core_1.Button, { onClick: function () { return onExportReport(false); }, className: 'btn btn-primary', disabled: !loader && modelDetails.selectedType ? false : true }, "Download Report"),
                    [TpaAllTrainee, TsaAllTrainee, CaSce, ScesTrainee, MDOSummary].includes(currentPage || Page) && react_1.default.createElement(core_1.Button, { onClick: function () { return onExportReport(true); }, className: 'btn btn-primary', disabled: !loader && modelDetails.selectedType ? false : true }, "Email Report"))) : null));
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
};
exports.default = DownloadCsvReportComponent;
